'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};
// TODO  ICON 引入


var Progress = (_temp = _class = function (_Component) {
  _inherits(Progress, _Component);

  function Progress(props) {
    _classCallCheck(this, Progress);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Progress).call(this, props));

    _this.state = {
      //loading: props.loading || false
    };
    return _this;
  }

  _createClass(Progress, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      //// 卸载后将延时器清掉
      //if (this.clickedTimeout) {
      //  clearTimeout(this.clickedTimeout);
      //}
      //if (this.timeout) {
      //  clearTimeout(this.timeout);
      //}
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props;
      var type = _props.type;
      var className = _props.className;
      var percent = _props.percent;
      var status = _props.status;
      var format = _props.format;
      var showInfo = _props.showInfo;
      var strokeWidth = _props.strokeWidth;
      var style = _props.style;
      var width = _props.width;

      var others = _objectWithoutProperties(_props, ['type', 'className', 'percent', 'status', 'format', 'showInfo', 'strokeWidth', 'style', 'width']);

      var prefixCls = this.props.prefixCls;

      if (!strokeWidth) {
        //strokeWidth的值 line时默认为10   circle为6
        if (type == "line") {
          strokeWidth = 10;
        } else {
          strokeWidth = 6;
        }
      }
      strokeWidth = type == "line" ? strokeWidth / 10 : strokeWidth;

      // lineProgress
      var center = strokeWidth / 2;
      var right = 100 - strokeWidth / 2;
      var linePathString = 'M ' + center + ',' + center + ' L ' + right + ',' + center;
      var viewBoxString = '0 0 100 ' + strokeWidth;
      var linePathStyle = {
        strokeDasharray: '100px, 100px',
        strokeDashoffset: 100 - percent + 'px',
        transition: 'stroke-dashoffset 0.6s ease 0s,stroke 0.6s ease'
      };

      //circleProgress
      var radius = 50 - strokeWidth / 2; //radius 圆的半径长
      var circlePathString = 'M 50,50 m 0,-' + radius + '\n     a ' + radius + ',' + radius + ' 0 1 1 0,' + 2 * radius + '\n     a ' + radius + ',' + radius + ' 0 1 1 0,-' + 2 * radius;
      var len = Math.PI * 2 * radius;
      var circlePathStyle = {
        strokeDasharray: len + 'px ' + len + 'px',
        strokeDashoffset: (100 - percent) / 100 * len + 'px',
        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
      };

      var strokeColorCls = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, prefixCls + '-stroke-default', percent !== 100 && status !== 'exception'), _defineProperty(_classNames, prefixCls + '-stroke-seccess', percent == 100), _defineProperty(_classNames, prefixCls + '-stroke-error', status == 'exception'), _classNames));

      var checkIcon = type == "line" ? _react2.default.createElement(_icon2.default, { type: 'check-circle' }) : _react2.default.createElement(_icon2.default, { type: 'check', style: { 'fontSize': width / 4 + 'px' } });

      var closeIcon = type == "line" ? _react2.default.createElement(_icon2.default, { type: 'cross-circle' }) : _react2.default.createElement(_icon2.default, { type: 'cross', style: { 'fontSize': width / 4 + 'px' } });

      var progressText = type == "line" ? _react2.default.createElement(
        'span',
        null,
        format(percent)
      ) : _react2.default.createElement(
        'span',
        { style: { 'fontSize': width / 4 + 'px' } },
        format(percent)
      );

      if (type == 'line') {
        return _react2.default.createElement(
          'div',
          { className: prefixCls + '-line  ' + className },
          _react2.default.createElement(
            'svg',
            _extends({
              viewBox: viewBoxString,
              preserveAspectRatio: 'none',
              style: style
            }, others),
            _react2.default.createElement('path', {
              className: prefixCls + '-trail',
              d: linePathString,
              strokeLinecap: 'round',
              strokeWidth: strokeWidth / 2,
              fillOpacity: '0'
            }),
            _react2.default.createElement('path', {
              className: prefixCls + '-line-path ' + strokeColorCls,
              d: linePathString,
              strokeLinecap: 'round',
              strokeWidth: strokeWidth / 2,
              fillOpacity: '0',
              style: linePathStyle
            })
          ),
          _react2.default.createElement(
            'span',
            { className: prefixCls + '-line-text' },
            showInfo ? percent == 100 ? _react2.default.createElement(
              'span',
              { className: prefixCls + '-checkIcon' },
              checkIcon
            ) : status === 'exception' ? _react2.default.createElement(
              'span',
              { className: prefixCls + '-closeIcon' },
              closeIcon
            ) : progressText : null
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          { style: { "width": width + 'px' }, className: prefixCls + '-circle-box ' + prefixCls + '-circle ' + className },
          _react2.default.createElement(
            'svg',
            _extends({
              viewBox: '0 0 100 100',
              style: style
            }, others),
            _react2.default.createElement('path', {
              className: prefixCls + '-trail',
              d: circlePathString,
              strokeWidth: strokeWidth / 2,
              fillOpacity: '0'
            }),
            _react2.default.createElement('path', {
              className: prefixCls + '-circle-path ' + strokeColorCls,
              d: circlePathString,
              strokeLinecap: 'round',
              strokeWidth: strokeWidth / 2,
              fillOpacity: '0',
              style: circlePathStyle
            })
          ),
          _react2.default.createElement(
            'span',
            { className: prefixCls + '-circle-text' },
            showInfo ? percent == 100 ? _react2.default.createElement(
              'span',
              { className: prefixCls + '-checkIcon' },
              checkIcon
            ) : status === 'exception' ? _react2.default.createElement(
              'span',
              { className: prefixCls + '-closeIcon' },
              closeIcon
            ) : progressText : null
          )
        );
      }
    }
  }]);

  return Progress;
}(_react.Component), _class.propTypes = {
  type: _propTypes2.default.oneOf(['line', 'circle']),
  percent: _propTypes2.default.number,
  showInfo: _propTypes2.default.bool,
  status: _propTypes2.default.string,
  format: _propTypes2.default.func,
  width: _propTypes2.default.number,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  type: 'line', //设置进度条类型，可选值为 success|exception|active 默认设置为line
  percent: 0,
  width: 132, // circle时为132
  showInfo: true,
  status: '',
  className: '',
  format: function format(percent) {
    return percent + '%';
  },
  prefixCls: 'mt-progress'
}, _temp);
exports.default = Progress;